export const SCALE = [
  { value: 1, label: "Completamente in disaccordo" },
  { value: 2, label: "In disaccordo" },
  { value: 3, label: "Né d'accordo né in disaccordo" },
  { value: 4, label: "D'accordo" },
  { value: 5, label: "Completamente d'accordo" },
];

export const AREAS = [
  {
    name: "Engagement",
    questions: [
      "Mi sento motivato nel mio lavoro.",
      "Trovo il mio lavoro stimolante.",
      "Sento che il mio contributo è apprezzato.",
      "Sono orgoglioso di lavorare qui.",
      "Mi sento entusiasta quando lavoro.",
    ],
  },
  {
    name: "Chiarezza: Vision, Mission, Ruoli, Processi",
    questions: [
      "Capisco la missione aziendale.",
      "I miei ruoli sono chiari.",
      "I processi sono ben strutturati.",
      "Il mio lavoro contribuisce agli obiettivi.",
      "Ricevo indicazioni chiare su cosa fare.",
    ],
  },
  {
    name: "Comunicazione a tutti i livelli",
    questions: [
      "La comunicazione con il mio superiore è efficace.",
      "Ricevo feedback costruttivo.",
      "Posso esprimere liberamente le mie idee.",
      "La comunicazione tra colleghi è fluida.",
      "La direzione comunica in modo trasparente.",
    ],
  },
  {
    name: "Stress Lavorativo",
    questions: [
      "Il mio carico di lavoro è sostenibile.",
      "Mi sento sotto pressione durante il lavoro.",
      "Ho tempo sufficiente per svolgere i miei compiti.",
      "Riesco a gestire lo stress lavorativo.",
      "Il lavoro non interferisce con il mio benessere.",
    ],
  },
  {
    name: "Equilibrio Vita-Lavoro",
    questions: [
      "Riesco a conciliare lavoro e vita privata.",
      "Il mio lavoro mi permette di avere tempo libero.",
      "L'azienda promuove il work-life balance.",
      "Mi sento riposato e rigenerato.",
      "Posso gestire le mie esigenze personali.",
    ],
  },
  {
    name: "Ambiente di Lavoro",
    questions: [
      "Gli spazi di lavoro sono adeguati.",
      "Ho accesso a strumenti necessari.",
      "L'ambiente fisico è confortevole.",
      "Le pause sono sufficienti.",
      "Mi sento sicuro sul posto di lavoro.",
    ],
  },
  {
    name: "Soddisfazione Lavorativa",
    questions: [
      "Sono soddisfatto della mia crescita professionale.",
      "Il mio stipendio è adeguato.",
      "Il mio lavoro è valorizzato.",
      "Mi sento riconosciuto per i miei successi.",
      "Ho opportunità di formazione.",
    ],
  },
  {
    name: "Relazioni e Clima Aziendale",
    questions: [
      "Il clima aziendale è positivo.",
      "Ho buoni rapporti con i colleghi.",
      "Mi sento supportato dai miei superiori.",
      "Lavoro bene in team.",
      "L'azienda promuove un buon clima lavorativo.",
    ],
  },
  {
    name: "Salute e Benessere",
    questions: [
      "Mi sento bene fisicamente.",
      "Non ho sintomi di stress eccessivo.",
      "L'azienda supporta il benessere mentale.",
      "Ho accesso a iniziative di salute aziendale.",
      "Mi sento energico durante il lavoro.",
    ],
  },
  {
    name: "Inclusività e Diversità",
    questions: [
      "L'azienda promuove un ambiente inclusivo e diversificato.",
      "Mi sento rispettato/a indipendentemente dalla mia identità personale.",
      "Le politiche aziendali sostengono l'uguaglianza.",
      "Le opportunità di crescita sono garantite a tutti, senza discriminazioni.",
      "Mi sento libero/a di essere me stesso/a sul luogo di lavoro.",
    ],
  },
  {
    name: "Opportunità di Innovazione",
    questions: [
      "Posso proporre nuove idee senza timore di giudizio.",
      "Ho la possibilità di lavorare su progetti innovativi.",
      "L'azienda incoraggia la creatività e la sperimentazione.",
      "Le idee proposte vengono valutate seriamente e, se valide, messe in pratica.",
      "L'azienda investe in modo concreto nel miglioramento e nell'innovazione.",
    ],
  },
  {
    name: "Supporto Tecnologico",
    questions: [
      "Gli strumenti tecnologici aziendali soddisfano le esigenze del mio lavoro.",
      "Ricevo supporto adeguato per problemi tecnici.",
      "I software utilizzati sono intuitivi e aggiornati.",
      "Ricevo formazione adeguata sull'uso degli strumenti digitali aziendali.",
      "La tecnologia a disposizione mi permette di lavorare in modo efficiente.",
    ],
  },
  {
    name: "Leadership e Management",
    questions: [
      "I leader aziendali comunicano una visione chiara.",
      "Mi sento supportato/a nella mia crescita professionale dai manager.",
      "Le decisioni aziendali sono trasparenti e ben spiegate.",
      "Il mio responsabile riconosce e valorizza il mio lavoro.",
      "I leader aziendali sono coerenti tra ciò che dicono e ciò che fanno.",
    ],
  },
];

export const REVERSE_INDEX = 16; // Area 4 (Stress), domanda 2 — punteggio invertito (6 - risposta)

export const AREA_NAMES_EN = [
  "Engagement",
  "Clarity: Vision, Mission, Roles, Processes",
  "Communication at all levels",
  "Work Stress",
  "Work-Life Balance",
  "Work Environment",
  "Job Satisfaction",
  "Relationships & Company Climate",
  "Health & Wellbeing",
  "Inclusivity & Diversity",
  "Innovation Opportunities",
  "Technology Support",
  "Leadership & Management",
];

export const areaBand = (score) => {
  if (score >= 21) return "Ottimo";
  if (score >= 16) return "Buono";
  if (score >= 11) return "Medio";
  if (score >= 6) return "Scarso";
  return "Molto scarso";
};

export const areaBandEn = (score) => {
  if (score >= 21) return "Excellent";
  if (score >= 16) return "Good";
  if (score >= 11) return "Average";
  if (score >= 6) return "Poor";
  return "Very poor";
};

export const globalBand = (score) => {
  if (score >= 274) return "Clima aziendale eccellente";
  if (score >= 217) return "Clima aziendale buono";
  if (score >= 159) return "Clima aziendale medio";
  if (score >= 101) return "Clima aziendale critico";
  return "Clima aziendale problematico";
};

export const globalBandEn = (score) => {
  if (score >= 274) return "Excellent company climate";
  if (score >= 217) return "Good company climate";
  if (score >= 159) return "Average company climate";
  if (score >= 101) return "Critical company climate";
  return "Problematic company climate";
};
